import { GET, PUT, DELETE, POST } from "constants/methods";

import { REACT_APP_API_PREFIX } from "config/env";

const service = "interdoc";
const notebooks = `${REACT_APP_API_PREFIX}/${service}/notebooks`;

export function getNotebooks(filters) {
  const url = `${notebooks}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getNotebookById(id) {
  const url = `${notebooks}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateNotebook(id, body) {
  const url = `${notebooks}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteNotebook(id) {
  const url = `${notebooks}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createNotebook(body) {
  const url = `${notebooks}`;
  return {
    method: POST,
    url,
    body,
  };
}
